export const iconNames = [
  "Wrench",
  "PersonStanding",
  "HandHelping",
  "AirVent",
  "Plug",
  "Dumbbell",
  "School2",
  "PaintRoller",
  "Sparkle",
  "PawPrint",
  "Laptop",
  "Toilet",
  "Truck",
  "Dog",
  "Baby",
  "Lightbulb",
  "Fan",
  "Radiation",
  "Droplet",
  "Thermometer",
  "ShieldAlert",
  "Bolt",
  "Stethoscope",
  "Syringe",
  "ChefHat",
  "Fish",
  "Feather",
  "Bone",
  "MoveRight",
  "Boxes",
  "Luggage",
  "Navigation",
  "ShoppingCart",
  "CreditCard",
  "BadgeCheck",
  "ClipboardCheck",
  "BrainCircuit",
  "HeartPulse",
  "Pill",
  "Apple",
  "BookOpen",
  "PenLine",
  "GraduationCap",
  "Presentation",
  "Monitor",
  "Server",
  "Code",
  "Cloud",
  "Database",
  "Compass",
  "Landmark",
  "Flag",
  "Languages",
  "Route",
  "Star",
  "Check",
  "AlertCircle",
  "Info",
  "Search",
  "ChevronDown"
];
